import EditPage from './EditPage';
import editPageReducer from './reducer';

export { editPageReducer };
export default EditPage;
